import React, { useCallback, useEffect, useState } from "react";
import { personalInfo, navLinks } from "../data/content";

function scrollToHash(hash) {
  const id = hash.replace(/^#/, "");
  if (!id) return;
  const el = document.getElementById(id);
  if (!el) return;
  const headerOffset = 80;
  const top = el.getBoundingClientRect().top + window.scrollY - headerOffset;
  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  window.scrollTo({ top, behavior: reduce ? "auto" : "smooth" });
  if (history.pushState) {
    history.pushState(null, "", `#${id}`);
  } else {
    window.location.hash = `#${id}`;
  }
}

export default function Header({ navOpen, setNavOpen }) {
  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === "Escape") setNavOpen(false);
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [setNavOpen]);

  const handleNavClick = useCallback(
    (event, href) => {
      if (!href.startsWith("#")) return;
      event.preventDefault();
      setNavOpen(false);
      scrollToHash(href);
    },
    [setNavOpen]
  );

  return (
    <header className="sticky top-0 z-40 border-b border-rule bg-canvas/95 backdrop-blur-sm">
      <div className="wrap flex h-16 items-center justify-between gap-4">
        <a
          href="#top"
          className="font-display text-sm font-semibold tracking-tight text-ink"
          onClick={(e) => handleNavClick(e, "#top")}
        >
          Jeremiah Magdael
        </a>

        <nav aria-label="Primary" className="hidden lg:block">
          <ul className="flex items-center gap-6">
            {navLinks.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  className="font-mono text-[0.6875rem] uppercase tracking-[0.06em] text-ink-secondary transition-colors hover:text-accent focus-visible:text-accent"
                  onClick={(e) => handleNavClick(e, link.href)}
                >
                  {link.name}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={personalInfo.resumeUrl}
            className="btn-secondary hidden sm:inline-flex"
            target="_blank"
            rel="noopener noreferrer"
          >
            Resume
          </a>
          <button
            type="button"
            className="inline-flex min-h-11 min-w-11 items-center justify-center border border-ink/20 px-3 font-mono text-[0.6875rem] uppercase tracking-[0.06em] lg:hidden"
            aria-expanded={navOpen}
            aria-controls="mobile-nav"
            onClick={() => setNavOpen((v) => !v)}
          >
            {navOpen ? "Close" : "Menu"}
          </button>
        </div>
      </div>

      {navOpen && (
        <div id="mobile-nav" className="border-t border-rule bg-canvas lg:hidden">
          <nav aria-label="Mobile" className="wrap py-4">
            <ul className="flex flex-col divide-y divide-rule">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="block py-4 font-mono text-xs uppercase tracking-[0.06em] text-ink"
                    onClick={(e) => handleNavClick(e, link.href)}
                  >
                    {link.name}
                  </a>
                </li>
              ))}
              <li>
                <a
                  href={personalInfo.resumeUrl}
                  className="block py-4 font-mono text-xs uppercase tracking-[0.06em] text-accent"
                  target="_blank"
                  rel="noopener noreferrer"
                  onClick={() => setNavOpen(false)}
                >
                  Resume
                </a>
              </li>
            </ul>
          </nav>
        </div>
      )}
    </header>
  );
}
